import FlexPane from './_flex-pane.js'
import Image from './_image.js'
import CountryIcons from './_country-icons.js'
import SportIcons from './_sport-icons.js'

export default {
  name: 'CountryIcon',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
        },
      },
    },
    icon: {
      configSet: Image,
      configValues: {
        style: {
          alignSelf: 'center',
          width: '16px',
          height: '16px',
        },
      },
    },
    countryIcons: {
      configSet: CountryIcons,
      configValues: {},
    },
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
